var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with ImageTracer.java version 1.1.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 0",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0.5 0.0 L 1920.0 0.5 L 1919.5 1080.0 L 0.0 1079.5 L 0.5 0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 0",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 461.5 41.0 L 1460.0 41.5 L 1459.5 1040.0 L 461.0 1039.5 L 461.5 41.0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 0",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 575.5 64.0 Q 579.5 63.5 580.0 66.5 Q 581.0 73.0 577.5 75.0 L 575.5 74.0 L 570.0 82.5 L 571.5 83.0 L 575.5 80.0 L 578.5 79.0 L 581.0 80.5 L 580.5 85.0 L 578.0 86.5 L 576.0 91.5 L 580.0 94.5 L 581.0 96.5 L 579.0 97.5 L 577.0 96.5 L 578.0 98.5 L 572.5 102.0 L 564.0 97.5 L 563.0 92.5 L 559.5 89.0 Q 554.8 88.3 553.0 90.5 L 551.5 93.0 L 550.0 93.5 L 549.5 95.0 L 547.0 96.5 Q 546.3 100.3 548.5 101.0 L 553.5 106.0 L 555.0 106.5 L 556.5 109.0 L 559.0 110.5 L 560.5 113.0 L 564.0 111.5 L 560.5 108.0 L 559.0 104.5 L 560.5 102.0 Q 565.3 100.8 566.5 103.0 L 571.0 104.5 L 567.5 106.0 L 562.5 104.0 Q 559.5 105.5 562.5 107.0 L 564.0 106.5 L 563.0 108.5 L 564.5 109.0 L 566.0 108.5 L 561.5 116.0 L 559.5 117.0 L 559.5 115.0 L 558.0 115.5 Q 559.3 120.8 556.5 122.0 L 552.5 127.0 L 551.0 126.5 L 548.5 130.0 L 546.0 130.5 L 547.0 132.5 L 544.0 133.5 L 542.5 136.0 L 540.0 137.5 L 535.5 144.0 L 533.0 144.5 L 529.5 149.0 L 526.0 147.5 L 524.5 145.0 L 522.0 143.5 L 521.5 142.0 L 519.0 141.5 L 518.5 139.0 L 517.0 138.5 L 515.5 136.0 Q 510.8 136.8 510.0 133.5 L 510.5 130.0 L 512.0 129.5 L 512.5 127.0 L 514.5 128.0 L 516.5 128.0 L 518.0 127.5 Q 514.5 126.0 517.0 124.5 L 517.5 123.0 L 521.0 120.5 L 521.5 119.0 L 523.0 118.5 L 523.5 116.0 L 531.0 114.5 L 529.5 112.0 L 532.0 111.5 L 534.5 106.0 L 536.0 105.5 L 536.5 104.0 L 544.5 101.0 L 546.5 102.0 L 545.5 100.0 L 544.0 99.5 L 545.5 95.0 L 550.0 91.5 L 550.5 90.0 L 552.0 89.5 L 553.5 87.0 Q 558.8 88.3 560.0 85.5 L 560.0 83.5 L 562.0 79.5 L 568.0 73.5 L 567.5 72.0 L 569.0 72.5 L 569.5 70.0 L 572.0 69.5 Q 571.5 64.5 575.5 64.0 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 1",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1139.5 65.0 L 1146.0 67.5 Q 1147.0 73.0 1143.5 74.0 L 1140.0 74.5 L 1140.0 76.5 L 1141.5 79.0 L 1144.0 80.5 L 1140.5 81.0 L 1139.5 78.0 L 1138.0 78.5 Q 1140.3 79.8 1137.5 81.0 L 1135.5 81.0 L 1134.0 80.5 L 1134.5 78.0 Q 1135.8 80.3 1137.0 77.5 L 1138.0 75.5 L 1134.5 74.0 L 1128.5 81.0 L 1126.0 80.5 L 1136.0 71.5 L 1137.5 66.0 L 1139.5 65.0 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 1",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 569.5 74.0 L 572.0 75.5 L 568.5 81.0 L 566.0 82.5 L 567.5 86.0 L 570.5 87.0 L 575.0 83.5 L 575.5 82.0 L 578.0 82.5 L 577.5 85.0 L 575.0 86.5 L 574.5 88.0 L 572.0 89.5 L 579.0 97.5 L 575.5 99.0 L 574.5 96.0 Q 572.8 98.8 571.0 94.5 L 562.0 85.5 Q 562.7 79.7 566.5 77.0 L 568.5 78.0 L 569.5 74.0 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 2",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1134.5 74.0 L 1138.0 75.5 L 1135.5 79.0 L 1134.0 78.5 L 1133.5 81.0 L 1129.0 80.5 L 1134.5 74.0 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 0",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 628.5 81.0 L 632.0 81.5 L 628.5 82.0 L 628.5 81.0 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 0",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632.5 81.0 L 636.0 81.5 L 632.5 82.0 L 632.5 81.0 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 0",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 636.5 81.0 L 1122.5 81.0 L 1252.5 81.0 L 1285.0 81.5 L 1303.0 83.5 Q 1338.2 88.8 1356.0 111.5 Q 1363.9 120.6 1368.0 133.5 L 1371.5 144.0 L 1374.0 159.5 L 1375.0 163.5 L 1375.5 172.0 L 1376.0 204.5 L 1376.0 333.5 L 1376.0 817.5 Q 1373.8 818.8 1375.0 823.5 L 1374.0 832.5 L 1372.5 842.0 Q 1366.2 872.7 1345.5 889.0 Q 1336.4 896.9 1323.5 901.0 L 1313.0 904.5 L 1297.5 907.0 L 1293.5 908.0 L 1285.0 908.5 L 1252.5 909.0 L 1122.5 909.0 L 636.5 909.0 Q 635.3 906.8 630.5 908.0 L 621.5 907.0 L 612.0 905.5 Q 581.3 899.2 565.0 878.5 Q 557.1 869.4 553.0 856.5 L 549.5 846.0 L 547.0 830.5 L 546.0 826.5 L 545.5 818.0 L 545.0 785.5 L 545.0 656.5 L 545.0 172.5 Q 547.3 171.3 546.0 166.5 L 547.0 157.5 L 548.5 148.0 Q 554.8 117.3 575.5 101.0 Q 591.4 87.4 617.5 84.0 L 620.5 83.0 L 629.5 82.0 Q 635.0 83.5 636.5 81.0 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 1",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1285.5 81.0 L 1289.0 81.5 L 1285.5 82.0 L 1285.5 81.0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 1",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1289.5 81.0 L 1293.0 81.5 L 1289.5 82.0 L 1289.5 81.0 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 2",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1380.5 81.0 L 1382.5 82.0 L 1386.5 81.0 Q 1389.7 84.8 1397.5 84.0 Q 1398.8 81.8 1403.5 83.0 L 1409.5 87.0 L 1420.0 97.5 L 1420.5 99.0 L 1430.0 107.5 Q 1432.7 109.8 1432.0 115.5 L 1429.5 121.0 L 1426.0 123.5 L 1425.5 125.0 L 1424.0 125.5 L 1424.5 127.0 Q 1423.3 124.8 1422.0 127.5 L 1421.5 129.0 L 1419.0 130.5 L 1417.5 133.0 L 1415.0 134.5 L 1414.5 136.0 L 1412.0 137.5 L 1408.5 142.0 L 1402.0 147.5 L 1401.5 149.0 L 1389.0 160.5 L 1387.5 163.0 L 1382.5 167.0 L 1382.5 165.0 L 1379.5 166.0 L 1375.0 163.5 L 1375.5 162.0 L 1383.5 163.0 L 1383.5 161.0 Q 1385.0 163.5 1386.5 160.0 L 1390.0 157.5 L 1388.5 155.0 L 1386.0 156.5 L 1387.0 158.5 L 1385.5 158.0 L 1384.0 158.5 L 1384.5 160.0 L 1382.5 160.0 L 1380.5 161.0 L 1375.0 157.5 L 1374.0 153.5 L 1376.0 154.5 L 1376.5 156.0 L 1382.5 158.0 Q 1388.1 156.1 1387.0 147.5 Q 1385.9 140.4 1390.0 138.5 L 1395.0 132.5 L 1393.5 133.0 L 1390.5 134.0 L 1383.5 135.0 L 1375.5 132.0 L 1374.0 132.5 L 1375.0 130.5 L 1371.0 127.5 L 1370.0 123.5 L 1369.0 116.5 L 1371.0 113.5 L 1372.5 109.0 L 1375.0 107.5 L 1375.5 106.0 L 1378.0 104.5 L 1378.5 103.0 Q 1392.5 100.5 1397.0 107.5 Q 1400.8 109.8 1400.0 116.5 L 1401.0 121.5 L 1398.0 126.5 L 1398.5 128.0 L 1397.0 128.5 L 1397.5 130.0 L 1404.5 124.0 L 1408.5 121.0 L 1415.5 119.0 L 1419.5 118.0 L 1421.5 119.0 Q 1425.8 118.3 1425.0 112.5 L 1420.0 108.5 L 1418.5 106.0 L 1417.0 105.5 L 1413.5 100.0 L 1405.5 93.0 Q 1404.8 89.3 1399.5 90.0 Q 1397.5 93.0 1391.5 92.0 L 1386.5 89.0 L 1382.5 89.0 L 1379.5 90.0 L 1376.0 93.5 L 1376.5 95.0 L 1375.0 94.5 L 1374.5 96.0 L 1372.0 97.5 L 1371.5 99.0 L 1369.0 100.5 L 1368.5 102.0 L 1365.0 104.5 L 1364.5 106.0 L 1362.0 107.5 L 1358.5 112.0 L 1355.0 110.5 L 1357.0 110.5 L 1357.5 109.0 L 1359.0 108.5 L 1360.5 106.0 L 1363.0 104.5 L 1363.5 103.0 L 1369.0 98.5 L 1368.5 97.0 L 1367.0 97.5 L 1363.0 100.5 L 1362.5 102.0 L 1359.0 103.5 L 1357.5 107.0 L 1354.5 109.0 Q 1349.7 106.5 1351.5 104.0 L 1350.0 103.5 L 1351.5 103.0 L 1353.5 107.0 L 1358.5 101.0 L 1365.0 96.5 L 1374.5 85.0 L 1380.5 81.0 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 3",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1379.5 84.0 Q 1386.3 82.7 1389.0 85.5 L 1396.5 87.0 L 1401.5 85.0 L 1403.5 85.0 L 1405.0 85.5 L 1403.0 86.5 L 1408.0 88.5 L 1413.0 93.5 L 1414.5 96.0 L 1417.0 97.5 L 1417.5 99.0 L 1420.0 100.5 L 1419.0 102.5 L 1420.5 103.0 Q 1421.8 100.8 1423.0 103.5 L 1429.0 109.5 L 1430.0 115.5 L 1428.0 116.5 L 1426.5 121.0 L 1425.0 121.5 L 1423.5 124.0 L 1422.0 124.5 L 1420.5 127.0 L 1416.0 130.5 L 1414.5 133.0 L 1409.0 137.5 L 1405.5 142.0 L 1404.0 142.5 L 1403.5 144.0 L 1402.0 144.5 L 1394.5 153.0 L 1393.0 153.5 L 1391.5 156.0 L 1390.0 156.5 L 1387.5 160.0 L 1385.0 161.5 Q 1383.8 164.3 1378.5 163.0 L 1375.0 161.5 L 1375.5 158.0 L 1380.5 161.0 L 1386.0 157.5 L 1386.5 156.0 L 1389.0 154.5 L 1388.0 146.5 Q 1388.9 139.9 1393.5 137.0 L 1408.0 123.5 L 1408.5 122.0 L 1416.5 122.0 L 1420.5 123.0 L 1425.0 119.5 L 1427.0 112.5 L 1425.5 109.0 L 1424.0 108.5 L 1422.5 106.0 L 1415.0 100.5 L 1411.5 95.0 L 1410.0 94.5 L 1409.5 93.0 L 1405.0 89.5 Q 1404.0 87.0 1399.5 88.0 L 1392.5 90.0 L 1388.0 87.5 Q 1387.3 85.3 1383.5 86.0 L 1377.5 90.0 L 1369.0 97.5 L 1364.5 103.0 L 1363.0 103.5 L 1361.5 106.0 L 1359.0 107.5 L 1358.5 109.0 L 1357.0 109.5 L 1356.5 111.0 L 1355.0 108.5 L 1358.0 106.5 L 1359.5 103.0 L 1363.0 101.5 L 1368.5 95.0 L 1370.0 94.5 L 1377.5 85.0 L 1379.5 84.0 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 4",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1383.5 88.0 L 1387.5 90.0 Q 1390.2 92.8 1396.5 92.0 Q 1397.9 89.4 1402.5 90.0 L 1414.0 100.5 L 1417.5 106.0 L 1420.0 107.5 L 1420.5 109.0 L 1425.0 112.5 Q 1425.8 118.3 1421.5 119.0 L 1419.5 120.0 Q 1418.0 117.5 1412.5 119.0 L 1409.5 121.0 Q 1404.5 120.5 1404.0 124.5 L 1395.0 132.5 L 1390.5 138.0 Q 1385.9 139.9 1387.0 147.5 Q 1388.1 156.1 1382.5 158.0 L 1376.0 155.5 L 1373.5 149.0 L 1371.0 140.5 L 1367.0 129.5 Q 1363.9 119.1 1357.0 112.5 L 1362.0 108.5 L 1363.5 106.0 L 1365.0 105.5 L 1367.5 102.0 L 1369.0 101.5 L 1370.5 99.0 L 1372.0 98.5 L 1373.5 96.0 L 1375.0 95.5 L 1380.5 89.0 L 1383.5 88.0 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 5",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 555.5 89.0 L 560.5 90.0 L 564.0 93.5 Q 563.0 98.0 565.5 99.0 L 573.0 102.5 Q 572.3 104.8 568.5 104.0 Q 566.5 101.0 560.5 102.0 L 559.0 106.5 L 563.5 112.0 L 560.5 113.0 L 557.5 109.0 L 555.0 107.5 L 554.5 106.0 L 547.0 99.5 Q 546.3 95.8 548.5 95.0 L 550.0 94.5 L 550.5 93.0 L 553.0 91.5 L 553.5 90.0 L 555.5 89.0 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 3",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 556.5 90.0 L 559.0 90.5 L 556.5 91.0 L 556.5 90.0 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 6",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 90.0 L 566.5 93.0 L 568.0 93.5 L 570.5 97.0 L 572.0 97.5 L 571.5 99.0 L 566.0 95.5 L 564.5 90.0 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 4",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1367.5 90.0 L 1366.5 92.0 L 1367.5 90.0 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 5",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 553.5 93.0 Q 558.8 91.8 560.0 94.5 L 561.0 97.5 L 558.0 100.5 Q 557.3 102.8 553.5 102.0 L 552.5 100.0 L 551.0 99.5 Q 550.5 95.0 554.0 94.5 L 553.5 93.0 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 7",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 556.5 94.0 L 558.5 97.0 L 555.5 100.0 L 553.5 97.0 L 556.0 95.5 L 556.5 94.0 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 6",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 96.0 L 1342.5 98.0 L 1341.0 97.5 L 1341.5 96.0 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 2",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 98.0 L 1343.5 100.0 L 1342.5 98.0 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 2",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 99.0 L 576.5 101.0 L 577.5 99.0 Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 7",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1344.5 99.0 L 1346.5 102.0 L 1344.5 99.0 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 3",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 574.5 101.0 L 571.5 105.0 L 574.5 101.0 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 4",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1347.5 102.0 L 1354.5 110.0 L 1347.5 102.0 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 8",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 562.5 104.0 L 569.0 106.5 L 566.0 108.5 L 564.5 109.0 L 563.0 108.5 L 561.0 105.5 L 562.5 104.0 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 9",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1382.5 105.0 Q 1391.6 103.9 1395.0 108.5 L 1398.0 113.5 L 1399.0 121.5 L 1393.5 130.0 Q 1390.3 133.8 1381.5 132.0 L 1374.0 127.5 L 1371.0 117.5 L 1372.5 112.0 L 1375.0 110.5 L 1376.5 108.0 L 1379.0 107.5 L 1379.5 106.0 L 1382.5 105.0 Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 10",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 550.5 106.0 L 552.0 106.5 L 553.0 108.5 L 551.5 108.0 L 550.0 107.5 L 550.5 106.0 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 5",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 569.5 106.0 L 565.5 111.0 L 569.5 106.0 Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 11",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 541.5 109.0 Q 545.0 111.0 540.5 113.0 L 539.0 113.5 L 538.5 116.0 L 537.5 114.0 L 536.0 114.5 L 539.0 112.5 L 541.5 109.0 Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 3",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 112.0 L 563.5 114.0 L 564.5 112.0 Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 6",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 113.0 L 1358.5 115.0 L 1357.5 113.0 Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 12",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 558.5 115.0 L 561.0 116.5 L 558.5 120.0 L 558.5 115.0 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 13",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 547.5 116.0 L 550.0 116.5 L 547.5 121.0 L 546.0 121.5 Q 543.4 122.9 544.0 127.5 L 544.5 129.0 L 541.5 127.0 L 539.0 128.5 L 534.5 134.0 L 534.0 132.5 L 538.0 123.5 L 536.0 120.5 L 538.0 120.5 L 538.5 119.0 L 539.5 121.0 L 543.0 120.5 L 543.5 119.0 L 547.0 117.5 L 547.5 116.0 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 14",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 117.0 L 535.5 119.0 L 534.5 117.0 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 15",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 526.5 118.0 Q 533.0 117.0 535.0 120.5 Q 536.5 126.5 533.5 128.0 Q 531.3 129.8 532.0 134.5 L 534.5 136.0 L 538.5 133.0 L 540.0 135.5 L 538.0 136.5 L 536.5 139.0 L 535.0 139.5 L 534.5 141.0 L 530.0 137.5 L 528.0 132.5 L 532.0 122.5 L 526.5 121.0 L 521.5 127.0 L 519.0 125.5 L 526.0 119.5 L 526.5 118.0 Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 16",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 129.0 L 520.5 135.0 L 525.0 137.5 L 531.0 144.5 L 527.5 146.0 L 521.5 139.0 L 518.0 136.5 L 517.5 135.0 L 512.0 132.5 L 513.5 130.0 L 515.5 129.0 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 17",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 541.5 129.0 L 544.0 130.5 L 541.5 134.0 L 541.0 132.5 L 542.0 130.5 L 541.5 129.0 Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 8",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 499.5 139.0 Q 501.0 142.5 502.5 140.0 L 509.5 141.0 L 511.5 141.0 L 516.0 143.5 L 516.5 145.0 L 520.0 147.5 L 522.0 150.5 L 523.0 154.5 L 514.5 164.0 L 513.0 164.5 L 511.5 167.0 L 510.0 167.5 L 508.5 170.0 L 507.0 170.5 L 505.5 173.0 L 500.5 174.0 L 497.5 170.0 L 494.0 169.5 L 494.5 168.0 L 492.0 165.5 L 490.0 160.5 L 489.0 152.5 L 491.5 149.0 L 496.0 145.5 L 496.5 144.0 L 500.0 141.5 L 499.5 139.0 Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 18",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 497.5 147.0 L 496.5 149.0 L 497.5 147.0 Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 19",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 518.5 149.0 L 520.0 151.5 L 519.0 151.5 L 518.5 149.0 Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 20",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 503.5 150.0 L 507.0 151.5 L 507.5 153.0 L 509.0 153.5 L 508.5 158.0 L 507.0 158.5 L 506.5 160.0 Q 501.0 160.5 499.0 157.5 Q 498.0 152.0 501.5 151.0 L 503.5 150.0 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 7",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 164.0 L 546.0 167.5 L 545.0 167.5 L 545.5 164.0 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 8",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1375.5 164.0 L 1376.0 167.5 L 1375.0 167.5 L 1375.5 164.0 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 21",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 495.5 165.0 L 500.5 171.0 L 495.5 165.0 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 4",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 168.0 L 546.0 171.5 L 545.0 171.5 L 545.5 168.0 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 5",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1375.5 168.0 L 1376.0 171.5 L 1375.0 171.5 L 1375.5 168.0 Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 9",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 261.0 L 1034.0 261.5 L 997.5 262.0 L 997.5 261.0 Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 22",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 262.0 L 1034.0 262.5 L 1003.5 370.0 L 923.5 656.0 L 886.0 655.5 L 890.0 644.5 L 896.0 623.5 L 919.0 541.5 L 977.0 333.5 L 992.0 280.5 L 995.5 268.0 Q 994.9 263.4 997.5 262.0 Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 10",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1064.5 333.0 L 1066.0 333.5 L 1064.0 334.5 L 1064.0 366.5 L 1064.0 374.5 Q 1063.3 378.8 1066.0 379.5 L 1063.0 377.5 L 1063.0 345.5 L 1063.0 337.5 Q 1062.3 333.8 1064.5 333.0 Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 23",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 853.5 334.0 L 856.0 334.5 L 856.0 366.5 L 856.0 374.5 Q 856.8 379.3 853.5 380.0 L 837.5 386.0 L 801.5 401.0 L 657.0 460.5 L 658.5 463.0 L 807.5 524.0 L 842.5 539.0 L 849.5 542.0 Q 854.3 542.3 856.0 545.5 L 855.5 589.0 L 826.5 577.0 L 784.5 559.0 L 605.0 482.5 L 605.5 439.0 L 853.5 334.0 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 9",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 856.5 334.0 L 857.0 377.5 L 855.0 378.5 L 856.0 375.5 L 856.0 366.5 L 856.5 334.0 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 24",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1064.5 334.0 L 1240.0 407.5 L 1288.5 428.0 L 1304.0 434.5 L 1316.0 440.5 L 1316.0 470.5 Q 1317.9 479.4 1314.5 483.0 L 1065.5 589.0 L 1064.0 585.5 L 1064.0 577.5 L 1064.0 545.5 L 1074.0 540.5 L 1083.5 537.0 L 1120.5 521.0 L 1263.0 462.5 L 1262.5 460.0 L 1121.5 402.0 L 1080.5 385.0 L 1064.0 377.5 L 1064.5 334.0 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 10",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1422.5 347.0 L 1428.0 349.5 L 1426.5 355.0 L 1425.0 355.5 L 1424.5 357.0 L 1422.0 358.5 L 1421.5 360.0 L 1420.0 360.5 L 1420.5 362.0 L 1415.0 366.5 L 1417.5 368.0 L 1420.5 364.0 L 1422.0 363.5 L 1423.5 361.0 L 1428.0 364.5 L 1427.5 368.0 L 1425.0 369.5 L 1424.5 371.0 L 1422.0 372.5 L 1422.5 374.0 L 1426.0 376.5 L 1426.5 378.0 L 1428.0 378.5 L 1426.5 382.0 L 1425.0 382.5 L 1425.5 384.0 L 1424.0 383.5 L 1423.5 385.0 L 1420.0 387.5 L 1419.5 389.0 L 1416.5 390.0 L 1411.5 388.0 L 1409.0 389.5 L 1412.0 391.5 L 1413.0 394.5 L 1410.5 398.0 L 1408.5 399.0 L 1406.0 397.5 Q 1406.4 403.9 1402.5 406.0 L 1401.0 406.5 L 1400.5 408.0 L 1398.0 409.5 L 1396.5 412.0 L 1394.5 413.0 L 1392.5 412.0 L 1393.0 413.5 L 1393.0 415.5 L 1390.5 418.0 L 1389.0 418.5 L 1383.5 425.0 L 1380.0 426.5 L 1377.5 431.0 L 1376.0 430.5 L 1376.5 428.0 L 1378.0 427.5 Q 1375.2 425.8 1376.0 420.5 L 1377.5 420.0 L 1380.5 424.0 L 1382.0 423.5 L 1382.5 422.0 L 1384.0 421.5 L 1383.0 419.5 Q 1384.8 421.1 1386.5 418.0 L 1388.0 417.5 L 1386.0 416.5 L 1387.5 414.0 L 1379.5 419.0 L 1379.0 413.5 L 1381.0 410.5 L 1380.5 409.0 L 1382.0 408.5 L 1383.0 406.5 L 1381.5 403.0 L 1376.0 400.5 L 1376.5 398.0 L 1378.0 397.5 L 1377.0 393.5 L 1383.0 388.5 L 1383.5 387.0 L 1392.0 383.5 L 1391.0 380.5 L 1396.0 376.5 L 1398.5 372.0 Q 1400.5 369.0 1406.5 370.0 L 1408.5 371.0 L 1408.0 369.5 Q 1406.5 362.5 1410.5 361.0 L 1413.0 359.5 L 1416.5 354.0 L 1418.0 353.5 L 1420.5 348.0 L 1422.5 347.0 Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 25",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1417.5 357.0 L 1420.0 357.5 L 1416.0 362.5 Q 1413.3 363.3 1414.0 367.5 L 1415.5 371.0 L 1422.0 366.5 L 1423.5 363.0 L 1426.0 364.5 L 1425.5 367.0 L 1423.0 368.5 L 1422.5 370.0 L 1420.0 371.5 L 1421.5 375.0 L 1426.0 379.5 Q 1423.3 384.8 1420.5 379.0 L 1413.0 372.5 L 1411.5 370.0 L 1410.0 369.5 L 1409.0 366.5 L 1411.0 366.5 L 1410.0 364.5 L 1417.5 357.0 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 11",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 532.5 364.0 Q 541.9 362.1 545.0 366.5 L 544.5 368.0 Q 541.9 364.6 534.5 366.0 L 533.0 368.5 L 534.5 369.0 L 538.5 367.0 L 543.5 370.0 L 545.0 369.5 L 545.0 371.5 L 544.5 373.0 L 536.5 370.0 L 526.0 379.5 L 524.5 382.0 L 522.0 383.5 L 521.5 385.0 L 513.0 392.5 L 512.5 394.0 L 509.0 396.5 L 510.0 403.5 Q 513.5 405.0 512.0 411.5 L 510.0 416.5 L 516.5 424.0 L 519.0 425.5 L 530.5 438.0 L 533.5 439.0 L 535.0 438.5 L 535.5 440.0 L 538.5 436.0 L 541.0 434.5 Q 538.6 422.6 544.5 419.0 L 545.0 422.5 Q 541.3 423.3 542.0 428.5 L 541.5 438.0 L 539.0 438.5 L 539.5 440.0 L 541.0 439.5 L 540.5 441.0 L 543.0 439.5 L 543.5 438.0 L 545.0 438.5 L 544.0 441.5 L 540.0 445.5 L 540.5 447.0 L 537.5 446.0 Q 536.0 448.5 530.5 447.0 L 522.0 439.5 L 519.5 436.0 L 518.0 435.5 L 513.5 430.0 L 510.5 432.0 L 510.0 430.5 Q 513.8 428.8 510.5 427.0 L 504.0 422.5 L 505.0 406.5 L 502.5 403.0 L 501.0 403.5 L 502.0 398.5 Q 501.4 393.4 504.5 392.0 L 507.5 388.0 L 509.0 387.5 L 509.5 386.0 L 513.0 383.5 L 514.5 381.0 L 516.0 380.5 L 517.5 378.0 L 519.0 377.5 L 520.5 375.0 L 523.0 373.5 L 523.5 372.0 L 530.0 366.5 L 530.5 365.0 L 532.5 364.0 Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 26",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 366.0 Q 542.5 364.5 545.0 368.5 L 544.5 371.0 L 538.5 367.0 L 533.0 369.5 L 532.5 371.0 L 530.0 372.5 L 528.5 375.0 L 527.0 375.5 L 525.5 378.0 L 519.0 383.5 L 518.5 385.0 L 509.0 392.5 L 507.0 397.5 L 506.0 403.5 L 509.0 404.5 L 510.0 409.5 L 508.0 417.5 L 511.5 422.0 L 513.0 422.5 Q 512.3 428.3 516.5 429.0 L 518.5 428.0 L 518.5 429.0 L 517.0 429.5 L 517.5 431.0 L 519.5 430.0 L 522.0 431.5 L 532.5 443.0 L 539.0 439.5 L 539.5 438.0 L 542.0 437.5 L 542.0 428.5 Q 541.3 423.8 544.5 423.0 L 545.0 437.5 L 543.0 438.5 L 541.5 441.0 L 539.0 442.5 L 538.5 444.0 L 535.5 443.0 L 534.5 445.0 Q 529.0 444.5 527.0 440.5 L 525.5 438.0 L 519.0 433.5 L 518.5 432.0 L 516.0 430.5 L 515.5 429.0 L 513.0 427.5 L 512.5 426.0 L 511.0 425.5 L 510.5 424.0 L 509.0 423.5 L 508.5 422.0 L 507.0 421.5 L 506.0 416.5 L 506.0 414.5 L 507.0 405.5 Q 502.3 403.8 504.0 395.5 L 506.5 392.0 L 508.0 391.5 L 521.5 377.0 L 525.0 375.5 Q 522.8 374.3 525.5 373.0 L 527.0 372.5 L 527.5 371.0 L 529.0 370.5 L 531.5 367.0 L 532.5 369.0 L 534.5 366.0 Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 27",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 536.5 370.0 L 545.0 373.5 L 544.5 386.0 L 541.5 385.0 L 534.5 385.0 L 527.0 389.5 Q 521.8 393.8 523.0 404.5 L 530.5 415.0 Q 535.3 417.3 543.5 416.0 L 545.0 415.5 Q 545.8 419.8 543.0 420.5 Q 540.0 422.5 541.0 428.5 Q 542.5 434.5 539.5 436.0 L 538.0 436.5 L 535.5 440.0 L 534.5 438.0 L 532.5 439.0 L 519.0 426.5 L 517.5 424.0 L 512.0 419.5 L 510.0 414.5 Q 513.2 412.2 512.0 405.5 Q 508.3 403.3 509.0 396.5 L 513.0 393.5 L 520.5 385.0 L 522.0 384.5 L 523.5 382.0 L 526.0 380.5 L 534.5 371.0 L 536.5 370.0 Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 12",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1403.5 373.0 L 1405.0 373.5 L 1403.0 374.5 L 1408.0 376.5 L 1407.0 381.5 L 1403.5 385.0 Q 1399.5 385.5 1399.0 382.5 L 1398.0 380.5 L 1400.5 377.0 L 1403.0 375.5 Q 1400.8 374.3 1403.5 373.0 Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 28",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1413.5 376.0 L 1416.5 380.0 L 1414.0 379.5 L 1413.5 376.0 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 29",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1403.5 377.0 Q 1405.8 377.8 1405.0 381.5 L 1402.5 383.0 L 1401.0 380.5 L 1404.0 378.5 L 1403.5 377.0 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 6",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 856.5 378.0 L 855.5 380.0 L 856.5 378.0 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 13",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 385.0 L 540.5 385.0 Q 544.3 384.3 545.0 386.5 L 544.5 388.0 Q 541.3 385.7 534.5 387.0 L 532.0 388.5 L 531.5 390.0 L 526.0 394.5 L 525.0 403.5 L 528.5 410.0 L 532.0 412.5 L 535.5 414.0 L 542.5 414.0 L 544.5 413.0 L 545.0 414.5 L 541.5 416.0 L 533.5 416.0 L 530.0 414.5 L 526.0 409.5 Q 521.7 406.3 523.0 397.5 L 528.5 388.0 L 534.5 385.0 Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 30",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 387.0 Q 542.0 385.5 545.0 388.5 L 544.5 413.0 Q 541.0 415.5 533.5 414.0 L 528.0 409.5 Q 524.0 406.0 525.0 397.5 L 530.5 390.0 L 532.0 389.5 L 532.5 388.0 L 534.5 387.0 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 31",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1386.5 387.0 Q 1392.6 385.9 1395.0 388.5 L 1397.5 394.0 L 1402.0 395.5 L 1403.0 401.5 L 1399.5 406.0 L 1398.0 406.5 L 1397.5 408.0 L 1396.0 408.5 L 1394.5 411.0 Q 1393.3 408.8 1388.5 410.0 L 1382.0 415.5 L 1384.0 403.5 L 1382.0 399.5 L 1385.0 399.5 L 1388.5 404.0 L 1393.0 400.5 L 1396.5 399.0 L 1397.0 400.5 L 1391.5 407.0 L 1390.0 407.5 L 1390.5 409.0 L 1394.5 407.0 Q 1396.3 409.8 1398.0 405.5 L 1396.0 404.5 L 1397.5 404.0 L 1399.0 404.5 L 1400.0 399.5 L 1397.5 396.0 Q 1391.3 396.8 1388.5 401.0 L 1388.0 399.5 L 1393.0 392.5 L 1390.5 390.0 L 1388.5 390.0 L 1386.0 390.5 L 1383.5 395.0 L 1380.5 397.0 Q 1377.8 395.8 1380.0 394.5 L 1383.0 391.5 L 1383.5 390.0 L 1385.0 389.5 L 1386.5 387.0 Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 32",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1389.5 392.0 L 1390.0 394.5 L 1388.0 395.5 L 1386.5 398.0 L 1385.0 397.5 L 1385.5 396.0 L 1388.0 394.5 L 1387.5 393.0 L 1389.5 392.0 Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 33",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1403.5 394.0 L 1404.5 396.0 L 1403.5 394.0 Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 34",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1376.5 401.0 L 1382.0 403.5 L 1383.0 406.5 L 1381.5 409.0 L 1380.0 409.5 L 1380.0 411.5 L 1379.0 418.5 L 1380.5 418.0 L 1384.0 416.5 L 1389.5 412.0 Q 1392.3 413.3 1390.0 414.5 L 1387.5 418.0 L 1384.0 420.5 L 1383.5 422.0 L 1382.0 422.5 L 1381.5 424.0 L 1379.0 422.5 L 1377.5 420.0 L 1376.0 419.5 L 1377.0 415.5 L 1376.0 412.5 L 1380.0 404.5 L 1376.0 403.5 L 1376.5 401.0 Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 14",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1376.5 404.0 L 1380.0 404.5 L 1376.5 412.0 L 1376.0 408.5 L 1377.0 406.5 L 1376.5 404.0 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 15",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1376.5 415.0 L 1377.0 418.5 L 1376.0 418.5 L 1376.5 415.0 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 35",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1376.5 425.0 L 1378.0 427.5 L 1376.5 428.0 L 1376.5 425.0 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 11",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 605.5 438.0 L 604.5 440.0 L 605.5 438.0 Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 16",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 604.5 440.0 L 605.0 481.5 L 604.0 481.5 L 604.5 440.0 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 7",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1316.5 440.0 L 1317.0 481.5 L 1316.0 481.5 L 1316.5 440.0 Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 17",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 657.5 460.0 L 659.0 462.5 L 657.0 461.5 L 657.5 460.0 Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 8",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1261.5 460.0 L 1262.0 461.5 L 1260.0 462.5 L 1261.5 460.0 Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 18",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1262.5 460.0 L 1263.0 462.5 L 1261.5 463.0 L 1262.0 461.5 L 1262.5 460.0 Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 12",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1315.5 482.0 L 1314.5 484.0 L 1315.5 482.0 Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 19",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 618.5 488.0 L 621.0 489.5 L 619.5 489.0 L 618.5 488.0 Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 20",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854.5 543.0 Q 857.5 543.5 857.0 547.5 L 857.0 556.5 L 857.0 589.5 L 854.5 590.0 L 854.5 589.0 L 856.0 588.5 L 856.0 556.5 L 856.0 548.5 Q 856.5 543.8 854.5 543.0 Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 13",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1063.5 545.0 L 1064.0 589.5 L 1063.0 589.5 L 1063.5 545.0 Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 21",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1125.5 563.0 L 1127.0 563.5 L 1124.5 565.0 L 1125.5 563.0 Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 22",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1064.5 588.0 L 1065.5 590.0 L 1064.0 589.5 L 1064.5 588.0 Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 23",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1379.5 646.0 L 1391.5 647.0 L 1395.5 649.0 Q 1398.1 645.6 1405.5 647.0 L 1411.0 651.5 L 1415.5 657.0 L 1417.0 656.5 Q 1414.3 658.3 1418.5 660.0 L 1420.0 659.5 Q 1417.3 661.3 1421.5 663.0 L 1423.0 662.5 Q 1420.8 663.8 1423.5 665.0 L 1425.0 665.5 L 1427.5 669.0 L 1429.0 669.5 Q 1433.7 672.3 1432.0 681.5 L 1427.5 687.0 L 1425.0 688.5 L 1424.5 690.0 L 1422.0 691.5 L 1421.5 693.0 L 1419.0 694.5 L 1418.0 696.5 L 1418.5 698.0 L 1416.5 697.0 L 1415.5 699.0 L 1412.0 701.5 L 1414.0 704.5 L 1411.5 703.0 L 1408.0 705.5 L 1407.5 707.0 L 1406.0 707.5 L 1407.0 709.5 L 1404.5 710.0 L 1402.0 711.5 L 1401.5 713.0 L 1399.0 714.5 L 1397.5 717.0 L 1396.0 717.5 L 1394.5 720.0 L 1392.0 721.5 L 1390.5 724.0 L 1389.0 724.5 L 1385.5 729.0 Q 1380.8 727.8 1379.5 730.0 L 1376.0 728.5 L 1376.5 726.0 L 1383.5 727.0 L 1386.0 725.5 L 1386.5 724.0 L 1392.0 719.5 L 1389.5 718.0 L 1385.5 723.0 L 1380.5 725.0 L 1376.0 722.5 L 1376.5 719.0 L 1377.5 721.0 L 1382.5 722.0 L 1386.5 718.0 Q 1389.3 716.8 1387.0 715.5 Q 1386.0 706.5 1389.5 702.0 Q 1390.8 704.3 1392.0 701.5 L 1393.0 699.5 L 1388.5 698.0 Q 1387.3 700.3 1382.5 699.0 L 1376.0 695.5 L 1376.5 693.0 L 1379.0 694.5 L 1379.5 696.0 Q 1392.0 698.0 1396.0 691.5 Q 1400.3 688.3 1399.0 679.5 Q 1397.4 672.6 1391.5 670.0 L 1385.5 669.0 L 1377.0 671.5 L 1376.5 673.0 L 1376.0 669.5 Q 1379.9 665.9 1388.5 667.0 Q 1396.6 668.4 1400.0 674.5 L 1401.0 687.5 L 1394.5 696.0 L 1391.0 697.5 L 1394.5 699.0 L 1396.5 696.0 L 1398.0 695.5 L 1399.5 693.0 L 1402.0 691.5 L 1402.5 690.0 L 1404.0 689.5 L 1406.5 685.0 L 1416.5 683.0 L 1420.5 684.0 L 1423.0 682.5 L 1424.5 680.0 L 1426.0 679.5 L 1424.5 676.0 L 1419.5 670.0 L 1418.0 669.5 L 1417.5 668.0 L 1414.0 665.5 L 1410.5 661.0 L 1409.0 661.5 L 1409.5 660.0 L 1408.0 659.5 L 1406.5 657.0 L 1404.0 655.5 L 1403.5 654.0 L 1398.5 655.0 L 1391.5 656.0 L 1383.5 652.0 L 1382.5 654.0 L 1384.0 654.5 L 1382.5 655.0 L 1380.5 654.0 L 1380.5 656.0 L 1379.0 655.5 L 1378.5 657.0 L 1377.0 657.5 L 1376.5 659.0 L 1376.0 656.5 L 1377.5 653.0 L 1384.5 650.0 L 1388.5 652.0 L 1392.5 653.0 L 1402.5 653.0 L 1404.5 653.0 L 1409.0 656.5 L 1409.5 658.0 L 1412.0 659.5 L 1412.5 661.0 Q 1413.8 658.8 1415.0 661.5 L 1420.5 669.0 L 1423.0 668.5 L 1414.5 658.0 L 1411.0 655.5 L 1410.5 654.0 L 1408.0 652.5 L 1407.5 651.0 Q 1403.7 648.3 1395.5 650.0 L 1391.5 651.0 L 1388.5 649.0 L 1381.5 648.0 L 1376.5 651.0 L 1376.0 649.5 L 1377.5 647.0 L 1379.5 646.0 Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 24",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 542.5 665.0 L 545.0 665.5 L 544.5 668.0 L 542.5 668.0 L 540.0 668.5 L 542.5 672.0 Q 543.8 669.8 545.0 672.5 L 544.5 677.0 L 540.0 680.5 L 541.5 683.0 L 544.5 681.0 L 545.0 683.5 Q 543.3 687.8 541.5 685.0 L 538.0 681.5 L 540.0 678.5 L 538.0 677.5 L 537.5 679.0 L 536.0 679.5 L 536.0 681.5 L 536.5 684.0 L 538.0 683.5 L 537.0 691.5 Q 539.0 696.0 541.0 692.5 L 542.5 690.0 L 544.0 690.5 L 544.5 686.0 L 545.0 697.5 Q 540.8 699.8 542.5 702.0 L 540.5 701.0 L 538.5 704.0 L 536.0 705.5 L 535.5 707.0 L 534.0 707.5 L 533.5 711.0 L 528.5 713.0 L 519.0 704.5 L 515.5 700.0 L 510.0 697.5 L 513.5 692.0 L 515.5 691.0 L 518.5 692.0 L 519.0 690.5 L 517.0 689.5 L 521.5 683.0 L 529.5 679.0 L 531.5 680.0 L 530.5 678.0 L 529.0 677.5 L 533.5 671.0 L 542.5 665.0 Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 36",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 667.0 Q 545.8 667.8 545.0 671.5 L 542.0 671.5 L 540.0 672.5 L 534.5 678.0 L 533.0 677.5 L 533.5 675.0 L 535.0 675.5 Q 534.5 671.5 537.5 671.0 L 540.0 669.5 L 540.5 668.0 L 543.5 667.0 Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 37",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1385.5 669.0 Q 1391.0 668.5 1393.0 671.5 L 1398.0 676.5 L 1399.0 686.5 L 1392.5 695.0 Q 1387.8 697.3 1379.5 696.0 L 1378.5 694.0 L 1376.0 692.5 L 1376.0 678.5 Q 1375.1 673.1 1377.5 671.0 L 1385.5 669.0 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 38",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 542.5 673.0 L 543.0 675.5 L 541.0 676.5 L 540.0 674.5 L 542.0 674.5 L 542.5 673.0 Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 39",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 539.5 676.0 L 539.5 678.0 L 538.0 680.5 L 542.5 686.0 L 545.0 684.5 L 543.5 691.0 Q 542.3 688.8 541.0 691.5 L 539.5 694.0 L 538.0 693.5 Q 538.5 697.5 535.5 698.0 L 534.0 695.5 Q 539.2 692.7 538.0 683.5 L 536.0 683.5 L 535.0 680.5 L 538.0 678.5 L 539.5 676.0 Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 40",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 543.5 677.0 L 545.0 677.5 L 544.5 681.0 L 541.5 683.0 L 540.0 680.5 L 543.5 677.0 Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 41",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 528.5 687.0 L 530.0 687.5 L 528.0 691.5 L 524.5 698.0 L 523.5 695.0 L 521.5 696.0 L 520.0 693.5 L 524.0 691.5 L 528.5 687.0 Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 42",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 515.5 693.0 L 519.0 695.5 L 523.5 703.0 L 529.0 705.5 L 531.0 708.5 L 528.5 710.0 L 525.5 706.0 L 520.0 701.5 L 513.0 697.5 Q 512.5 693.5 515.5 693.0 Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 43",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 526.5 696.0 L 527.0 698.5 L 526.0 698.5 L 526.5 696.0 Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 25",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 503.5 703.0 Q 504.9 705.6 509.5 705.0 L 513.5 706.0 L 515.0 705.5 L 514.5 707.0 L 516.0 707.5 L 517.5 710.0 L 519.0 710.5 L 519.5 712.0 L 521.0 711.5 L 520.5 713.0 L 523.0 713.5 L 523.0 717.5 L 522.0 720.5 L 519.0 723.5 L 512.5 730.0 L 509.5 735.0 L 507.5 735.0 L 504.5 738.0 Q 499.4 738.6 498.0 735.5 L 496.5 733.0 L 495.0 732.5 Q 490.8 729.7 490.0 723.5 L 490.0 721.5 L 489.0 717.5 L 491.0 716.5 L 492.5 713.0 L 495.0 711.5 L 496.5 709.0 L 498.0 708.5 L 498.5 707.0 L 503.5 703.0 Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 44",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 530.5 704.0 L 531.5 706.0 L 530.5 704.0 Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 45",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 512.5 707.0 L 514.5 710.0 L 512.5 707.0 Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 46",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 502.5 709.0 L 507.5 711.0 L 510.5 709.0 L 513.0 710.5 L 514.5 714.0 L 517.0 714.5 L 519.0 718.5 L 517.0 717.5 L 516.5 716.0 L 515.5 718.0 L 512.5 719.0 L 511.5 716.0 L 510.0 715.5 L 508.5 713.0 L 502.5 712.0 L 499.0 714.5 L 498.0 721.5 L 501.5 726.0 L 505.0 727.5 L 504.5 733.0 L 500.5 731.0 L 495.0 725.5 L 496.0 723.5 L 494.0 717.5 L 496.0 716.5 L 497.5 714.0 L 501.0 711.5 L 502.5 709.0 Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 47",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 498.5 710.0 L 497.5 712.0 L 498.5 710.0 Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 48",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 516.5 711.0 L 521.5 717.0 L 520.0 716.5 L 516.5 711.0 Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 49",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 502.5 715.0 Q 508.3 714.2 510.0 717.5 L 509.5 721.0 L 508.0 721.5 L 506.5 724.0 Q 501.4 724.6 500.0 721.5 Q 499.0 716.0 502.5 715.0 Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 50",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 516.5 720.0 L 519.0 721.5 L 515.0 724.5 L 514.5 726.0 L 512.0 727.5 L 511.5 729.0 L 510.5 727.0 L 506.5 733.0 L 506.0 729.5 L 516.5 720.0 Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 26",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1394.5 721.0 L 1393.5 723.0 L 1394.5 721.0 Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 9",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 818.0 L 546.0 821.5 L 545.0 821.5 L 545.5 818.0 Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 10",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1375.5 818.0 L 1376.0 821.5 L 1375.0 821.5 L 1375.5 818.0 Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 14",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 822.0 L 546.0 825.5 L 545.0 825.5 L 545.5 822.0 Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 15",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1375.5 822.0 L 1376.0 825.5 L 1375.0 825.5 L 1375.5 822.0 Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 27",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1362.5 870.0 L 1361.5 872.0 L 1362.5 870.0 Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 28",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 561.5 874.0 L 563.0 876.5 L 560.0 876.5 L 561.5 874.0 Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 16",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 562.5 875.0 L 563.5 877.0 L 562.5 875.0 Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 11",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 876.0 L 1356.5 878.0 L 1357.5 876.0 Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 29",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 564.5 878.0 L 565.5 880.0 L 564.5 878.0 Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 30",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1356.5 878.0 L 1358.0 878.5 L 1357.5 881.0 L 1354.5 882.0 L 1354.5 881.0 L 1356.0 880.5 Q 1353.8 879.3 1356.5 878.0 Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 17",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 880.0 L 573.5 888.0 L 566.5 880.0 Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 18",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1354.5 880.0 L 1352.5 883.0 L 1354.5 880.0 Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 12",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 883.0 L 1350.5 885.0 L 1351.5 883.0 Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 31",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 884.0 L 1352.0 885.5 L 1348.5 888.0 L 1351.5 884.0 Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 19",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1349.5 885.0 L 1347.5 888.0 L 1349.5 885.0 Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 32",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 572.5 888.0 L 576.0 889.5 L 574.5 889.0 Q 571.5 889.5 572.5 888.0 Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 33",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 888.0 L 1345.5 890.0 L 1346.5 888.0 Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 20",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 890.0 L 578.5 892.0 L 577.5 890.0 Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 21",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 890.0 L 1342.5 892.0 L 1343.5 890.0 Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 34",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 892.0 L 1346.0 894.5 L 1344.5 895.0 L 1342.5 894.0 L 1337.5 896.0 L 1338.5 894.0 L 1342.0 893.5 L 1341.5 892.0 Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 35",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 582.5 894.0 L 581.5 896.0 L 582.5 894.0 Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 36",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1333.5 898.0 L 1333.5 900.0 L 1332.5 902.0 Q 1329.0 900.0 1333.5 898.0 Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 37",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1329.5 900.0 L 1328.5 902.0 L 1329.5 900.0 Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 38",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 594.5 901.0 L 597.0 901.5 L 594.5 902.0 L 594.5 901.0 Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 39",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1417.5 906.0 Q 1422.0 905.0 1423.0 907.5 Q 1424.5 915.5 1419.5 917.0 Q 1418.3 914.8 1417.0 917.5 L 1414.0 922.5 L 1416.5 923.0 L 1417.5 921.0 L 1420.5 920.0 Q 1424.5 920.5 1424.0 925.5 L 1422.0 926.5 L 1420.5 929.0 L 1418.0 930.5 L 1418.5 932.0 L 1420.0 931.5 Q 1417.5 933.0 1421.0 934.5 L 1421.5 936.0 L 1423.0 936.5 L 1421.5 942.0 L 1418.0 943.5 L 1420.0 944.5 L 1416.0 946.5 L 1416.5 948.0 L 1408.5 947.0 L 1404.5 946.0 L 1403.5 948.0 L 1408.0 951.5 Q 1408.8 956.3 1405.5 957.0 L 1401.0 957.5 Q 1401.6 963.1 1398.0 964.5 L 1390.5 972.0 L 1389.0 972.5 L 1385.0 977.5 L 1382.5 982.0 L 1380.5 982.0 L 1377.0 985.5 L 1376.5 989.0 L 1375.5 985.0 L 1373.5 990.0 Q 1369.3 990.8 1368.5 988.0 L 1361.0 982.5 L 1358.5 978.0 Q 1352.8 978.8 1352.0 974.5 L 1356.5 968.0 L 1359.0 967.5 L 1359.5 965.0 L 1362.0 963.5 L 1362.5 962.0 L 1365.0 960.5 L 1365.5 959.0 L 1367.0 958.5 L 1365.0 957.5 L 1366.5 957.0 L 1369.5 958.0 L 1373.0 956.5 L 1372.0 953.5 L 1378.0 947.5 L 1383.0 944.5 L 1383.5 942.0 L 1387.5 943.0 L 1386.0 940.5 L 1389.5 935.0 L 1392.0 933.5 L 1392.5 932.0 L 1395.0 930.5 L 1395.5 929.0 L 1401.5 928.0 L 1403.5 929.0 L 1403.0 927.5 L 1402.0 924.5 L 1411.5 913.0 L 1414.0 912.5 L 1415.5 908.0 L 1417.0 907.5 L 1417.5 906.0 Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 22",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 628.5 908.0 L 632.0 908.5 L 628.5 909.0 L 628.5 908.0 Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 13",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 632.5 908.0 L 636.0 908.5 L 632.5 909.0 L 632.5 908.0 Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 14",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1285.5 908.0 L 1289.0 908.5 L 1285.5 909.0 L 1285.5 908.0 Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 23",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1289.5 908.0 L 1293.0 908.5 L 1289.5 909.0 L 1289.5 908.0 Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 40",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 856.5 911.0 Q 863.0 910.0 864.0 914.5 L 863.5 917.0 L 862.0 917.5 L 864.0 918.5 L 861.0 919.5 L 860.5 921.0 Q 859.3 918.8 858.0 921.5 L 851.0 929.5 L 852.5 932.0 L 854.5 929.0 L 857.0 927.5 L 857.5 926.0 L 862.5 925.0 L 865.0 929.5 L 859.0 936.5 L 861.5 940.0 L 862.5 938.0 L 863.0 939.5 L 861.0 946.5 L 862.0 948.5 L 859.5 949.0 L 856.0 951.5 Q 855.3 953.8 851.5 953.0 L 845.5 950.0 Q 842.8 951.3 845.0 952.5 L 845.5 954.0 L 849.0 956.5 L 846.5 962.0 Q 842.3 962.8 841.5 960.0 L 841.0 964.5 L 839.5 968.0 L 836.5 972.0 L 834.0 973.5 L 833.5 975.0 L 829.0 976.5 Q 829.5 981.5 825.5 982.0 L 824.0 982.5 L 811.5 996.0 L 801.5 985.0 L 796.0 984.5 L 800.0 983.5 Q 794.4 983.6 793.0 979.5 L 796.5 973.0 L 800.0 973.5 L 800.5 975.0 L 801.0 972.5 L 801.0 970.5 L 808.5 962.0 L 814.0 961.5 L 812.0 958.5 L 815.5 954.0 L 821.0 950.5 L 822.5 948.0 L 829.0 947.5 Q 826.3 946.8 827.0 942.5 L 831.0 940.5 L 835.5 935.0 Q 837.8 932.3 843.0 932.5 Q 842.5 927.0 845.5 925.0 L 851.5 919.0 L 855.0 917.5 L 854.0 915.5 L 854.5 914.0 L 856.5 911.0 Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 51",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 854.5 919.0 L 855.0 922.5 L 852.0 923.5 L 852.0 925.5 L 851.5 927.0 L 849.0 928.5 L 852.5 934.0 L 854.0 933.5 L 854.5 932.0 L 857.0 930.5 L 857.5 929.0 L 860.5 928.0 L 861.0 929.5 L 859.5 932.0 L 857.0 933.5 L 856.5 935.0 L 855.0 935.5 L 861.0 943.5 L 858.5 945.0 L 856.5 942.0 L 854.0 940.5 L 853.5 939.0 L 851.0 937.5 L 850.5 936.0 L 848.0 934.5 L 847.5 933.0 L 845.0 931.5 Q 844.3 927.3 847.0 926.5 L 854.5 919.0 Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 41",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1098.5 927.0 L 1105.5 928.0 L 1109.5 930.0 L 1111.5 929.0 Q 1113.0 931.5 1118.5 930.0 L 1122.5 929.0 L 1132.0 936.5 L 1137.5 943.0 L 1139.0 943.5 L 1140.5 946.0 L 1142.0 946.5 L 1143.5 949.0 L 1147.0 951.5 Q 1151.7 954.3 1150.0 963.5 L 1145.5 969.0 L 1143.0 970.5 L 1138.5 976.0 L 1137.0 976.5 L 1134.5 982.0 L 1135.0 980.5 L 1134.5 979.0 L 1132.5 982.0 L 1130.0 983.5 L 1129.0 985.5 L 1129.5 987.0 L 1127.5 986.0 L 1126.5 988.0 L 1123.0 990.5 L 1124.0 992.5 L 1122.5 992.0 L 1119.0 994.5 L 1118.5 996.0 L 1117.0 996.5 L 1118.0 998.5 L 1115.5 999.0 L 1113.0 1000.5 L 1112.5 1002.0 L 1110.0 1003.5 L 1110.5 1005.0 L 1112.5 1004.0 L 1111.5 1006.0 L 1109.5 1005.0 L 1106.0 1007.5 L 1105.5 1009.0 L 1097.5 1012.0 L 1087.0 1005.5 Q 1087.5 1001.5 1084.5 1001.0 L 1075.5 992.0 L 1073.0 990.5 L 1072.5 988.0 L 1070.0 987.5 L 1068.0 979.5 L 1070.0 971.5 L 1066.0 964.5 L 1067.0 961.5 L 1068.0 957.5 L 1072.0 953.5 L 1070.0 952.5 L 1070.5 951.0 Q 1072.5 955.0 1074.5 951.0 L 1076.0 950.5 L 1078.0 947.5 L 1077.5 946.0 Q 1079.0 948.5 1080.5 945.0 L 1082.0 944.5 L 1083.5 942.0 L 1085.0 941.5 L 1086.5 937.0 L 1089.0 936.5 L 1089.0 934.5 L 1088.0 932.5 L 1090.0 933.5 L 1090.5 935.0 L 1098.5 927.0 Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 42",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 532.5 928.0 L 538.5 928.0 Q 542.8 927.3 543.5 930.0 L 545.5 930.0 L 547.5 931.0 Q 550.1 927.6 557.5 929.0 L 563.0 933.5 L 563.5 935.0 L 567.0 936.5 L 580.5 952.0 L 584.0 954.5 L 586.0 960.5 Q 582.4 969.9 574.5 975.0 L 572.0 976.5 L 569.0 980.5 L 571.0 981.5 L 569.5 982.0 L 567.5 982.0 L 566.0 982.5 L 561.5 988.0 L 559.0 988.5 L 557.5 992.0 L 552.0 997.5 Q 554.3 998.8 551.5 1000.0 L 550.0 999.5 L 549.5 1001.0 L 544.0 1004.5 L 540.5 1009.0 L 538.0 1010.5 Q 536.8 1013.3 531.5 1012.0 L 518.0 1000.5 L 515.5 997.0 L 512.0 994.5 L 506.5 988.0 L 505.0 987.5 L 504.5 985.0 L 503.0 984.5 L 504.0 976.5 L 505.0 972.5 L 503.5 969.0 L 502.0 968.5 L 502.5 957.0 L 504.0 956.5 L 505.5 954.0 L 507.0 953.5 L 508.5 951.0 L 513.0 947.5 L 514.5 945.0 L 516.0 944.5 L 517.5 942.0 L 519.0 941.5 L 520.5 939.0 L 522.0 938.5 L 523.0 936.5 L 523.0 934.5 L 523.5 933.0 L 525.5 934.0 L 529.0 931.5 L 529.5 929.0 L 532.5 928.0 Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 52",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1401.5 930.0 L 1404.5 933.0 L 1406.0 936.5 L 1407.5 940.0 L 1415.0 943.5 Q 1414.0 946.0 1409.5 945.0 L 1405.5 942.0 L 1401.0 947.5 L 1404.5 951.0 Q 1407.3 952.3 1405.0 953.5 L 1404.5 955.0 L 1400.0 951.5 L 1398.5 949.0 L 1389.0 940.5 L 1389.5 938.0 Q 1393.7 932.2 1401.5 930.0 Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 53",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1408.5 933.0 L 1410.5 936.0 L 1412.0 936.5 L 1413.5 939.0 L 1415.0 939.5 L 1416.0 941.5 L 1411.5 938.0 L 1410.0 937.5 L 1408.5 933.0 Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 54",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 839.5 935.0 Q 844.3 935.3 846.0 938.5 L 847.5 945.0 Q 851.3 944.3 852.0 946.5 L 852.5 948.0 L 854.5 947.0 L 855.5 949.0 L 854.0 949.5 L 853.5 951.0 Q 851.3 947.3 844.5 948.0 L 842.0 949.5 L 846.0 958.5 L 842.5 959.0 L 829.0 943.5 L 830.5 943.0 L 831.5 945.0 L 832.5 942.0 L 834.0 941.5 L 833.5 940.0 L 836.0 939.5 L 839.5 935.0 Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 43",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 910.5 936.0 L 916.0 937.5 L 910.5 939.0 L 910.5 936.0 Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 44",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1037.5 936.0 L 1039.0 936.5 L 1038.5 938.0 L 1037.0 937.5 L 1037.5 936.0 Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 45",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 948.5 937.0 L 951.0 938.5 L 950.5 940.0 L 949.5 938.0 L 948.5 937.0 Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 46",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 965.5 937.0 L 970.0 937.5 L 965.5 938.0 L 965.5 937.0 Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 55",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1398.5 937.0 L 1402.0 937.5 L 1397.5 941.0 Q 1394.0 939.0 1398.5 937.0 Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 47",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 839.5 938.0 L 844.0 941.5 L 843.0 944.5 L 843.5 946.0 L 838.5 949.0 L 834.0 945.5 L 835.5 942.0 L 839.5 938.0 Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 56",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 848.5 938.0 L 854.0 942.5 L 855.0 944.5 L 853.5 945.0 L 850.0 942.5 L 849.5 940.0 L 848.0 939.5 L 848.5 938.0 Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 15",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 864.5 938.0 L 869.0 938.5 L 864.5 939.0 L 864.5 938.0 Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 1",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 938.0 L 873.0 939.5 L 873.5 959.0 L 893.0 958.5 L 893.0 945.5 Q 891.8 940.3 894.5 939.0 L 898.5 938.0 L 904.0 940.5 L 904.0 976.5 L 904.0 985.5 L 902.5 991.0 L 894.0 990.5 L 893.0 983.5 L 892.5 968.0 L 879.5 968.0 Q 874.3 966.8 873.0 969.5 L 872.5 991.0 L 866.5 991.0 L 863.0 989.5 L 863.5 939.0 Q 868.3 940.3 869.5 938.0 Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 16",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 895.5 938.0 L 898.0 938.5 L 895.5 939.0 L 895.5 938.0 Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 17",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 899.5 938.0 L 902.0 938.5 L 899.5 939.0 L 899.5 938.0 Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 48",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 905.5 938.0 L 906.0 939.5 L 905.0 943.5 L 905.0 952.5 L 905.0 988.5 L 906.0 990.5 L 904.0 989.5 L 904.0 952.5 L 904.0 943.5 Q 903.0 939.0 905.5 938.0 Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 18",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 911.5 938.0 L 949.0 938.5 L 911.5 939.0 L 911.5 938.0 Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 49",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 956.5 938.0 L 958.0 938.5 L 956.5 941.0 L 956.5 938.0 Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 19",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 960.5 938.0 L 970.0 938.5 L 960.5 939.0 L 960.5 938.0 Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 50",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 976.5 938.0 L 977.0 940.5 L 976.5 943.0 L 975.0 942.5 L 974.0 940.5 L 976.5 938.0 Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 51",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 999.5 938.0 L 1000.5 940.0 L 999.5 938.0 Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 20",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 938.0 L 1014.0 938.5 L 1005.5 939.0 L 1005.5 938.0 Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 52",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1016.5 938.0 L 1021.0 944.5 L 1019.5 944.0 L 1018.0 943.5 L 1018.0 941.5 L 1016.5 938.0 Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 24",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1030.5 938.0 L 1029.5 940.0 L 1030.5 938.0 Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 21",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1031.5 938.0 L 1035.0 938.5 L 1031.5 939.0 L 1031.5 938.0 Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 2",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 938.0 L 1040.0 939.5 L 1040.5 982.0 L 1057.0 982.5 L 1058.0 988.5 L 1056.5 991.0 L 1037.5 991.0 Q 1031.5 992.5 1030.0 989.5 L 1030.5 939.0 L 1035.5 938.0 Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 22",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1036.5 938.0 L 1039.0 938.5 L 1036.5 939.0 L 1036.5 938.0 Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 53",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1040.5 938.0 L 1041.5 981.0 L 1057.0 981.5 L 1040.5 982.0 L 1040.5 938.0 Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 23",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 873.5 939.0 L 874.0 958.5 L 873.0 958.5 L 873.5 939.0 Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 54",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 875.5 939.0 L 876.0 940.5 L 874.5 941.0 L 875.5 939.0 Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 3",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 911.5 939.0 L 950.0 939.5 L 949.5 946.0 L 947.5 947.0 L 944.5 946.0 L 937.5 946.0 L 935.0 947.5 L 935.0 978.5 L 935.0 986.5 Q 935.8 990.3 933.5 991.0 Q 926.8 992.8 925.0 989.5 L 925.0 958.5 L 925.0 950.5 Q 925.8 946.8 923.5 946.0 L 920.5 947.0 L 913.5 947.0 L 911.0 945.5 L 911.5 939.0 Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 4",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 958.5 939.0 L 967.5 939.0 Q 972.3 938.3 974.0 940.5 L 986.5 975.0 L 989.0 973.5 L 995.5 955.0 L 1002.5 939.0 L 1011.5 939.0 Q 1016.0 938.0 1017.0 940.5 L 1016.5 991.0 L 1008.0 990.5 L 1007.5 947.0 L 996.5 977.0 L 993.5 985.0 Q 993.7 989.7 990.5 991.0 L 982.0 990.5 L 967.5 948.0 L 966.0 950.5 L 967.0 952.5 L 966.0 954.5 L 966.0 956.5 L 967.0 958.5 Q 964.8 959.8 966.0 964.5 L 966.0 966.5 L 967.0 968.5 Q 964.8 969.8 966.0 974.5 L 966.0 976.5 L 967.0 978.5 Q 964.8 979.8 966.0 984.5 L 966.0 986.5 L 967.0 988.5 L 965.5 991.0 L 957.0 990.5 L 957.0 953.5 L 957.0 944.5 Q 956.0 940.0 958.5 939.0 Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 25",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1001.5 939.0 L 1000.5 941.0 L 1001.5 939.0 Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 26",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 862.5 940.0 L 863.0 989.5 L 862.0 989.5 L 862.5 940.0 Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 24",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 910.5 940.0 L 911.0 944.5 L 910.0 944.5 L 910.5 940.0 Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 27",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 950.5 940.0 L 951.0 944.5 L 950.0 944.5 L 950.5 940.0 Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 57",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 839.5 941.0 L 842.0 942.5 L 839.5 946.0 L 836.0 944.5 L 839.5 941.0 Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 28",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 956.5 941.0 L 957.0 990.5 L 956.0 990.5 L 956.5 941.0 Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 25",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1017.5 941.0 L 1018.0 989.5 L 1017.0 989.5 L 1017.5 941.0 Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 55",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 875.5 942.0 L 877.0 944.5 L 875.0 943.5 L 875.5 942.0 Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 56",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 951.5 942.0 L 953.0 947.5 L 951.5 948.0 L 950.0 945.5 L 951.5 942.0 Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 57",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 955.5 942.0 L 956.0 944.5 L 955.0 944.5 L 955.5 942.0 Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 58",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1384.5 945.0 L 1386.5 946.0 L 1388.0 945.5 L 1391.0 948.5 L 1392.5 952.0 Q 1397.5 951.5 1398.0 955.5 L 1399.0 960.5 L 1392.0 966.5 L 1390.5 969.0 L 1388.0 967.5 L 1389.5 965.0 L 1391.5 964.0 Q 1392.8 966.3 1394.0 963.5 L 1392.0 962.5 L 1395.0 960.5 Q 1395.8 956.8 1393.5 956.0 L 1391.5 955.0 L 1389.0 956.5 L 1392.0 957.5 L 1393.0 959.5 L 1387.0 963.5 L 1387.5 965.0 L 1386.0 964.5 L 1385.5 968.0 L 1383.5 967.0 L 1380.5 972.0 L 1379.0 972.5 L 1377.5 975.0 L 1376.0 974.5 Q 1379.5 970.0 1380.0 962.5 L 1378.5 960.0 L 1376.0 958.5 L 1381.0 954.5 L 1382.5 952.0 L 1383.0 954.5 L 1381.5 957.0 L 1380.0 957.5 L 1380.5 961.0 L 1382.0 960.5 L 1384.5 964.0 L 1389.0 957.5 L 1385.5 960.0 L 1383.0 959.5 L 1383.5 957.0 L 1386.0 955.5 L 1388.0 950.5 Q 1387.3 948.3 1383.5 949.0 L 1382.5 951.0 L 1381.5 949.0 Q 1381.0 954.5 1376.5 956.0 L 1375.0 953.5 L 1378.0 951.5 L 1377.5 950.0 L 1384.5 945.0 Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 26",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 937.5 946.0 L 947.0 946.5 L 937.5 947.0 L 937.5 946.0 Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 58",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 977.5 946.0 L 978.5 948.0 L 980.0 948.5 L 977.5 949.0 L 977.5 946.0 Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 29",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 924.5 947.0 L 925.0 989.5 L 924.0 989.5 L 924.5 947.0 Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 27",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 935.5 948.0 L 936.0 988.5 L 935.0 988.5 L 935.5 948.0 Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 28",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 967.5 948.0 L 967.0 949.5 L 966.5 951.0 L 966.0 949.5 L 967.5 948.0 Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 30",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1007.5 948.0 L 1008.0 989.5 L 1007.0 989.5 L 1007.0 961.5 L 1007.0 954.5 L 1006.0 950.5 L 1007.5 948.0 Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 59",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1393.5 948.0 L 1396.5 952.0 L 1393.5 948.0 Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 59",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 914.5 949.0 L 915.5 951.0 L 914.5 949.0 Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 29",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1029.5 949.0 L 1030.0 954.5 L 1029.0 954.5 L 1029.5 949.0 Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 60",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 951.0 Q 543.4 949.6 547.0 953.5 Q 552.5 958.0 552.0 968.5 L 546.5 976.0 Q 543.0 980.0 533.5 978.0 L 525.0 970.5 L 524.0 963.5 Q 525.5 956.5 530.5 953.0 L 534.5 951.0 Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 61",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 832.5 951.0 L 835.5 955.0 L 834.0 954.5 L 832.5 951.0 Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 62",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1101.5 951.0 Q 1109.9 950.1 1113.0 954.5 Q 1118.3 958.2 1117.0 968.5 L 1112.5 976.0 L 1109.5 977.0 L 1106.5 978.0 L 1099.5 978.0 L 1093.0 974.5 Q 1088.5 971.0 1090.0 961.5 L 1091.5 958.0 L 1093.0 957.5 L 1094.5 954.0 L 1101.5 951.0 Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 63",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1384.5 951.0 L 1385.0 953.5 L 1384.0 953.5 L 1384.5 951.0 Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 60",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 994.5 952.0 L 995.5 954.0 L 994.5 952.0 Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 64",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1398.5 952.0 L 1400.0 954.5 L 1399.0 954.5 L 1398.5 952.0 Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 61",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 953.0 L 1007.0 953.5 L 1004.0 959.5 L 1005.0 962.5 L 1004.0 962.5 L 1003.0 959.5 L 1005.5 953.0 Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 62",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 968.5 954.0 L 970.0 956.5 L 969.5 958.0 L 970.5 960.0 L 969.0 959.5 L 968.0 957.5 L 968.0 955.5 L 968.5 954.0 Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 63",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 993.5 954.0 L 994.5 956.0 L 993.5 954.0 Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 64",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 891.5 957.0 L 892.5 959.0 L 874.0 958.5 L 885.5 958.0 Q 890.3 959.3 891.5 957.0 Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 65",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 981.5 957.0 L 983.5 960.0 L 981.0 959.5 L 981.5 957.0 Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 66",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 993.5 957.0 L 994.0 958.5 L 992.5 961.0 L 991.0 960.5 L 993.5 957.0 Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 67",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829.5 958.0 L 828.5 960.0 L 829.5 958.0 Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 30",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 966.5 959.0 L 967.0 964.5 L 966.0 964.5 L 966.5 959.0 Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 31",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1029.5 959.0 L 1030.0 964.5 L 1029.0 964.5 L 1029.5 959.0 Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 65",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1369.5 959.0 Q 1375.9 959.1 1378.0 963.5 L 1376.0 970.5 L 1375.0 975.5 L 1377.5 977.0 L 1385.5 971.0 L 1386.0 972.5 L 1380.5 980.0 L 1375.5 982.0 L 1373.5 979.0 L 1371.0 977.5 Q 1370.3 971.8 1372.5 969.0 L 1373.5 971.0 L 1374.0 963.5 L 1369.5 963.0 L 1367.5 966.0 L 1362.5 968.0 L 1362.0 966.5 L 1365.0 965.5 L 1365.5 963.0 L 1367.0 962.5 L 1369.5 959.0 Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 68",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 982.5 961.0 L 986.0 963.5 L 985.5 965.0 L 983.0 963.5 L 982.5 961.0 Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 69",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 971.5 962.0 L 973.0 964.5 L 971.0 963.5 L 971.5 962.0 Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 70",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 990.5 962.0 L 992.0 962.5 L 991.5 964.0 L 990.0 963.5 L 990.5 962.0 Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 66",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 812.5 964.0 L 815.0 964.5 L 815.5 966.0 L 817.0 966.5 L 818.0 971.5 L 816.5 975.0 L 815.0 975.5 Q 813.8 980.8 816.5 982.0 L 820.0 980.5 L 825.5 976.0 Q 828.3 977.3 826.0 978.5 L 822.5 982.0 L 821.0 982.5 L 817.5 987.0 L 811.0 981.5 L 815.0 968.5 L 810.5 967.0 L 807.0 969.5 L 806.5 971.0 L 805.0 971.5 L 804.5 973.0 L 802.0 971.5 L 804.5 968.0 L 806.0 967.5 L 807.5 965.0 L 812.5 964.0 Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 71",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 861.5 965.0 L 862.0 982.5 Q 860.3 989.3 863.5 991.0 L 865.0 991.5 L 863.5 992.0 L 860.0 990.5 Q 862.5 989.0 861.0 983.5 L 861.5 965.0 Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 67",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1370.5 965.0 L 1372.0 965.5 L 1370.0 969.5 L 1369.0 977.5 L 1370.5 980.0 L 1365.0 974.5 Q 1361.0 972.5 1365.0 970.5 L 1365.5 969.0 L 1370.5 965.0 Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 72",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 971.5 966.0 L 972.5 968.0 L 974.0 967.5 L 975.0 970.5 L 973.0 971.5 Q 970.0 969.7 971.5 966.0 Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 73",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 984.5 966.0 L 987.0 967.5 L 984.5 968.0 L 984.5 966.0 Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 31",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 874.5 968.0 L 893.0 968.5 L 874.5 969.0 L 874.5 968.0 Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 74",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1000.5 968.0 L 1002.0 970.5 L 1000.0 969.5 L 1000.5 968.0 Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 68",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 811.5 969.0 L 812.0 972.5 Q 808.3 974.8 809.0 981.5 L 810.5 984.0 L 809.0 983.5 L 807.5 981.0 Q 804.8 982.3 807.0 983.5 L 810.5 988.0 L 812.0 988.5 L 812.5 990.0 L 814.0 990.5 L 810.5 992.0 L 803.5 983.0 L 795.0 978.5 L 796.5 976.0 Q 800.3 975.3 801.0 977.5 L 804.5 982.0 L 806.0 981.5 L 805.0 978.5 L 802.0 975.5 L 807.0 973.5 L 811.5 969.0 Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 32",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 873.5 969.0 L 874.0 989.5 L 873.0 989.5 L 873.5 969.0 Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 33",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 966.5 969.0 L 967.0 974.5 L 966.0 974.5 L 966.5 969.0 Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 75",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986.5 969.0 L 987.5 972.0 L 989.0 971.5 L 987.5 974.0 L 986.5 969.0 Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 34",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1029.5 969.0 L 1030.0 977.5 L 1029.0 977.5 L 1029.5 969.0 Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 69",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 971.0 L 1365.0 976.5 L 1371.5 985.0 L 1373.0 985.5 L 1371.5 988.0 L 1362.0 978.5 Q 1360.6 974.4 1355.0 974.5 L 1357.5 971.0 Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 32",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 986.5 972.0 L 988.0 974.5 L 986.0 973.5 L 986.5 972.0 Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 76",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 972.0 L 1006.0 974.5 L 1005.0 974.5 L 1005.5 972.0 Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 77",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1078.5 972.0 L 1079.0 974.5 L 1078.0 974.5 L 1078.5 972.0 Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 78",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 975.5 973.0 L 975.5 975.0 L 977.0 975.5 L 976.5 978.0 L 974.0 974.5 L 975.5 973.0 Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 79",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 875.5 975.0 L 876.0 986.5 L 875.0 986.5 L 875.5 975.0 Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 80",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 975.0 L 999.0 975.5 L 998.5 977.0 L 997.0 976.5 L 997.5 975.0 Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 81",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 997.5 978.0 L 998.0 980.5 L 995.0 982.5 L 997.5 978.0 Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 35",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 966.5 979.0 L 967.0 984.5 L 966.0 984.5 L 966.5 979.0 Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 36",
    fill: "rgb(101,101,101)",
    stroke: "rgb(101,101,101)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1029.5 979.0 L 1030.0 987.5 L 1029.0 987.5 L 1029.5 979.0 Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 82",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1345.5 981.0 L 1350.5 983.0 L 1354.5 982.0 L 1366.0 994.5 L 1363.5 1000.0 L 1358.0 1004.5 L 1358.5 1006.0 L 1356.5 1006.0 L 1354.0 1008.5 Q 1356.8 1010.3 1352.5 1012.0 L 1348.0 1014.5 Q 1347.3 1016.8 1343.5 1016.0 L 1333.5 1005.0 L 1332.0 1004.5 L 1333.0 999.5 Q 1330.5 998.0 1332.0 992.5 L 1336.0 990.5 L 1339.5 985.0 L 1341.0 984.5 L 1340.0 982.5 L 1341.0 982.5 L 1341.5 984.0 L 1342.5 982.0 L 1345.5 981.0 Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 83",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1058.5 983.0 L 1060.0 985.5 L 1059.0 987.5 Q 1061.3 988.8 1058.5 990.0 L 1058.5 983.0 Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 70",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 983.0 L 1349.0 984.5 L 1346.5 985.0 L 1346.5 983.0 Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 84",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 979.5 984.0 L 980.0 986.5 L 979.0 986.5 L 979.5 984.0 Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 85",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 994.5 984.0 L 995.0 986.5 L 994.0 986.5 L 994.5 984.0 Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 71",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1344.5 984.0 L 1337.5 992.0 L 1344.5 984.0 Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 86",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 785.5 985.0 L 790.5 988.0 Q 791.3 985.3 795.5 986.0 L 801.5 994.0 L 805.0 996.5 Q 806.5 1005.0 801.0 1006.5 L 791.5 1018.0 L 790.0 1017.5 L 787.5 1020.0 L 784.5 1021.0 L 783.5 1019.0 L 781.0 1018.5 L 776.5 1012.0 L 774.0 1010.5 L 772.0 999.5 L 779.5 991.0 L 781.0 990.5 L 782.5 988.0 L 784.0 987.5 L 785.5 985.0 Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 72",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1345.5 986.0 L 1351.5 988.0 L 1352.5 986.0 L 1358.5 992.0 Q 1363.0 994.0 1359.5 996.0 L 1355.5 995.0 L 1354.5 997.0 L 1352.5 992.0 Q 1349.8 989.2 1343.5 990.0 L 1340.5 994.0 L 1340.0 995.5 Q 1339.3 1001.7 1343.5 1003.0 L 1347.0 1004.5 Q 1348.3 1009.8 1345.5 1011.0 L 1343.0 1009.5 Q 1345.8 1007.8 1341.5 1006.0 L 1340.0 1005.5 L 1338.5 1003.0 L 1337.0 1002.5 Q 1338.3 997.8 1336.0 996.5 L 1337.5 994.0 L 1339.0 993.5 L 1339.5 992.0 L 1341.0 991.5 L 1345.5 986.0 Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 87",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 987.0 L 1008.0 990.5 L 1005.0 988.5 L 1005.5 987.0 Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 73",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 785.5 988.0 L 784.5 990.0 L 785.5 988.0 Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 88",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 874.5 988.0 L 876.5 989.0 L 878.0 988.5 L 876.5 991.0 L 874.0 989.5 L 874.5 988.0 Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 89",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 922.5 988.0 L 928.0 991.5 L 922.5 993.0 L 922.5 992.0 L 925.0 991.5 L 922.0 990.5 L 922.5 988.0 Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 90",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 936.5 988.0 L 937.0 989.5 L 934.5 993.0 L 933.5 991.0 L 936.0 989.5 L 936.5 988.0 Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 91",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 993.5 988.0 L 996.0 989.5 L 992.0 991.5 L 991.5 994.0 L 990.0 991.5 L 994.0 989.5 L 993.5 988.0 Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 92",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1019.5 988.0 L 1018.5 990.0 L 1019.5 988.0 Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 93",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1028.5 988.0 L 1030.0 990.5 L 1028.0 991.5 L 1030.5 992.0 Q 1032.0 989.5 1037.5 991.0 L 1057.5 991.0 L 1057.5 992.0 L 1031.0 992.5 L 1033.0 993.5 L 1031.5 994.0 L 1028.5 993.0 L 1026.0 991.5 L 1028.0 990.5 L 1028.5 988.0 Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 94",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 967.5 989.0 L 968.0 990.5 Q 967.0 994.0 961.5 993.0 L 961.5 992.0 L 967.0 990.5 L 967.5 989.0 Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 74",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 782.5 990.0 L 783.0 991.5 L 781.0 992.5 L 782.5 990.0 Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 95",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 981.5 990.0 L 984.0 991.5 L 980.5 994.0 L 978.5 994.0 L 977.0 993.5 L 982.0 991.5 L 981.5 990.0 Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 75",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1359.5 990.0 L 1362.0 991.5 L 1360.5 991.0 L 1359.5 990.0 Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 76",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786.5 991.0 L 793.5 993.0 L 795.5 993.0 L 797.0 993.5 L 799.5 997.0 L 801.0 1000.5 L 799.5 1001.0 L 796.5 1000.0 L 794.5 1001.0 L 792.5 998.0 L 791.0 998.5 L 792.0 1002.5 L 789.5 1006.0 L 784.0 1006.5 L 784.5 1008.0 L 788.0 1008.5 L 786.0 1012.5 L 787.0 1014.5 L 786.0 1014.5 L 785.5 1013.0 L 784.5 1015.0 L 779.5 1009.0 L 778.0 1008.5 L 780.0 1005.5 L 778.0 1004.5 L 777.0 1000.5 L 780.5 996.0 L 782.0 996.5 L 780.0 1000.5 L 780.0 1002.5 L 781.5 1006.0 L 784.0 1005.5 L 782.0 1001.5 L 784.5 997.0 L 788.5 996.0 Q 790.3 999.8 792.0 996.5 L 788.5 994.0 L 787.0 994.5 L 786.5 993.0 L 785.5 995.0 L 782.0 994.5 L 786.5 991.0 Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 33",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 865.5 991.0 L 871.0 991.5 L 865.5 992.0 L 865.5 991.0 Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 96",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 894.5 991.0 L 895.0 993.5 L 894.0 993.5 L 894.5 991.0 Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 34",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 895.5 991.0 L 901.0 991.5 L 895.5 992.0 L 895.5 991.0 Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 97",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 901.5 991.0 L 904.0 992.5 L 902.5 992.0 L 901.5 991.0 Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 35",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 928.5 991.0 L 933.0 991.5 L 928.5 992.0 L 928.5 991.0 Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 36",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 959.5 991.0 L 965.0 991.5 L 959.5 992.0 L 959.5 991.0 Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 37",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 984.5 991.0 L 990.0 991.5 L 984.5 992.0 L 984.5 991.0 Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    desc: "l 5 p 38",
    fill: "rgb(142,142,142)",
    stroke: "rgb(142,142,142)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1010.5 991.0 L 1016.0 991.5 L 1010.5 992.0 L 1010.5 991.0 Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 98",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 817.5 992.0 L 816.5 994.0 L 817.5 992.0 Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 99",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 867.5 992.0 L 870.0 993.5 L 867.5 994.0 L 867.5 992.0 Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 77",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1345.5 992.0 L 1351.0 993.5 L 1352.0 997.5 L 1349.5 1001.0 L 1347.5 1000.0 L 1345.5 1001.0 L 1342.0 998.5 Q 1341.0 994.0 1343.5 993.0 L 1345.5 992.0 Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 100",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 863.5 993.0 L 866.0 993.5 L 863.5 994.0 L 863.5 993.0 Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 78",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 993.0 L 1335.0 994.5 L 1334.5 998.0 L 1334.0 994.5 L 1335.5 993.0 Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 101",
    fill: "rgb(244,244,244)",
    stroke: "rgb(244,244,244)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1349.5 995.0 L 1350.5 997.0 L 1349.5 995.0 Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 79",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1362.5 996.0 L 1361.5 998.0 L 1362.5 996.0 Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 80",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1356.5 998.0 L 1361.0 999.5 L 1359.5 1000.0 L 1358.0 999.5 L 1356.5 1003.0 L 1350.5 1009.0 L 1348.0 1007.5 L 1348.5 1006.0 L 1350.0 1005.5 L 1352.5 1002.0 L 1355.0 1000.5 L 1356.5 998.0 Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 81",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 801.5 1002.0 L 798.5 1006.0 L 796.0 1006.5 L 794.5 1010.0 L 790.5 1015.0 Q 788.3 1014.3 789.0 1010.5 L 794.5 1005.0 L 798.5 1003.0 L 801.5 1002.0 Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 82",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1336.5 1005.0 L 1337.5 1007.0 L 1336.5 1005.0 Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 83",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1339.5 1008.0 L 1340.5 1010.0 L 1339.5 1008.0 Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 84",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 782.5 1015.0 L 783.5 1017.0 L 782.5 1015.0 Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 85",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 787.5 1016.0 L 786.5 1018.0 L 787.5 1016.0 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.9c955946507322834cdb36882e981938.svg";
export { ForwardRef as ReactComponent };